import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('overview-additional-information-section', []);

interface OverviewAdditionalInformationSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    additionalInformation: Array<AdditionalInformationItem>;
}

interface AdditionalInformationItem {
    label: string;
    value: string | number;
    testId: string;
}

function getFormattedAdditionalInformation(policyInfo: CustomerPolicyInfo) {
    const propertyData = policyInfo.property_data;
    const optionalCoverages = policyInfo.optional_coverages;
    const additionalInformation: Array<AdditionalInformationItem> = [];

    if (propertyData.wood_stove) {
        additionalInformation.push({
            label: 'Uncommon Secondary Heating',
            value: propertyData.wood_stove ? 'Yes' : 'No',
            testId: 'uncommon_secondary_heating'
        });
    }

    if (optionalCoverages.workers_compensation_details && optionalCoverages.workers_compensation_details.inservent) {
        additionalInformation.push({
            label: 'In House Employees',
            value: optionalCoverages.workers_compensation_details.inservent,
            testId: 'in_house_employees'
        });
    }

    if (optionalCoverages.workers_compensation_details && optionalCoverages.workers_compensation_details.outservent) {
        additionalInformation.push({
            label: 'Outdoor Employees',
            value: optionalCoverages.workers_compensation_details.outservent,
            testId: 'outdoor_employees'
        });
    }

    if (optionalCoverages.held_in_trust) {
        additionalInformation.push({
            label: 'Owned By Trust',
            value: optionalCoverages.held_in_trust ? 'Yes' : 'No',
            testId: 'owned_by_trust'
        });
    }

    if (propertyData.daycare) {
        additionalInformation.push({
            label: 'Daycare On Site',
            value: propertyData.daycare ? 'Yes' : 'No',
            testId: 'daycare_on_site'
        });
    }

    return additionalInformation;
}

module.component('overviewAdditionalInformationSection', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(this: OverviewAdditionalInformationSectionController) {
        this.$onInit = function() {
            this.additionalInformation = getFormattedAdditionalInformation(this.policyInfo);
        };
    }
});

export { module, getFormattedAdditionalInformation };
